export class TimeZone {
  constructor(public name: string, public displayName: string, public value: string) {}
}
